import type {
    V1ShellToApp,
    V1ShellToWeb,
} from "@khanacademy/embedded-webapp-schema";
import {listenForSignal, sendSignal} from "@khan/integrations";

import type {UXStackMessenger} from "../guide-api/types.ts";
import {UXStack} from "../guide-api/ux-stack.ts";

const mobileShellMessenger: UXStackMessenger = Object.freeze({
    listenForCloseDismissable(handler) {
        return listenForSignal<V1ShellToWeb.CloseDismissibleUX>(
            "shell:closeDismissibleUX",
            handler,
        );
    },
    sendStackUpdate(breadcrumbs) {
        sendSignal({type: "shell:uxopenedclosed", data: {breadcrumbs}});
    },
});

/**
 * Singleton instance of our UX stack.
 */
let _uxStack: UXStack<V1ShellToApp.Breadcrumb> | void;
/**
 * Accessor to ensure we only create an instance iff we need it.
 */
export function uxStack() {
    _uxStack = _uxStack ?? new UXStack(mobileShellMessenger);
    return _uxStack;
}

/**
 * Reset any persistent module state.
 *
 * Providing this so that we can tidy-up between tests.
 */
export function reset() {
    if (_uxStack != null) {
        _uxStack.tearDown();
        _uxStack = undefined;
    }
}
